import React from 'react'
import { Routes, Route, BrowserRouter} from "react-router-dom";
import { Inicio } from '../components/Inicio';
import { HeaderNav } from '../layout/HeaderNav';
import { Footer } from '../layout/Footer';
import { Pago } from '../components/Pago';


export const MisRutas = () => {
  return (
   <BrowserRouter>
      {/* Header*/}
        <HeaderNav/>

      {/* Contenido principal*/}
      <Routes>
        <Route path='/' element={<Inicio/>} />
        <Route path='Inicio' element={<Inicio/>} />
        <Route path="Comprar" element={<Pago/>} />
      </Routes>

      {/* Footer*/}
      <Footer/>

   </BrowserRouter>
  )
}
